import IComponent from "components/commons/IComponent";
import "./LeftPanel.scoped.css";

import LayerSetting from "components/LayerSetting";
import ZoomTo from "components/ZoomTo";
import Measurement from "components/Measurement";
import SplitScreen from "components/SplitScreen";
import SearchResult from "components/SearchResult";
import LDSPanel from "components/LDSPanel";
import GPTools from "components/GPTools";
import RainfallTool from "components/RainfallTool/RainfallTool";
import GetArcGISToken from "utils/GetArcGISToken";

import {
  setSplitViewMode,
  setSplitViewModeClose,
  toggleMapType,
} from "store/globalSlice";
import { connect } from "react-redux";

let MENU_ITEMS = [
  {
    name: "Zoom To Location",
    icon: "icn_menu_search",
    component: ZoomTo,
    isEnabled: true,
  },
  {
    name: "Layer Setting",
    icon: "icn_menu_overlay",
    component: LayerSetting,
    isEnabled: true,
  },
  {
    name: "Measurement",
    icon: "icn_menu_measure",
    component: Measurement,
    isEnabled: true,
  },
  // {
  //   name: "LDS Panel",
  //   icon: "icn_menu_LDS",
  //   component: LDSPanel,
  //   isEnabled: true,
  // },
  {
    name: "Search Result",
    icon: "icn_menu_searchresult",
    component: SearchResult,
    isEnabled: false,
  },
  {
    name: "Split",
    icon: "icn_tool_split",
    component: SplitScreen,
    isEnabled: false,
  },
  {
    name: "Geoprocessing Tools",
    icon: "icn_filter",
    component: GPTools,
    hideFrom567: true,
    isEnabled: true,
  },
  {
    name: "Rainfall Tool",
    icon: "icn_tool_rainfall",
    component: RainfallTool,
    hideFrom567: true,
    isEnabled: true,
  },
];

const DEFAULT_PANEL = 0;

class LeftPanel extends IComponent {
  static MENU_ITEM_INDICES = MENU_ITEMS.reduce(
    (p, c, i) => ((p[c.name] = i), p),
    {}
  );

  constructor(props) {
    super(props);
    this.state = {};
    if ([5, 6, 7].includes(GetArcGISToken.user.userGroup)) {
      MENU_ITEMS = MENU_ITEMS.filter((i) => !i.hideFrom567);
    }
  }
  componentDidMount() {
    let firstPanel = this.props.isCompactMode ? -1 : DEFAULT_PANEL;
    this.props.menuItemClickedCallback(MENU_ITEMS[firstPanel], firstPanel);
  }
  componentWillUnmount() {}
  componentDidUpdate(prevProps, prevState) {
    // console.log("check index", prevProps.activeIndex, this.props.activeIndex);
    let index = this.props.activeIndex;
    if (prevProps.activeIndex != index && index !== null) {
      this.props.menuItemClickedCallback(MENU_ITEMS[index], index);
      // console.log("check index", index);
      if (MENU_ITEMS[index] && !MENU_ITEMS[index].isEnabled) {
        MENU_ITEMS[index].isEnabled = true;
      }
    }

    if (prevProps.activeIndex == 4 && this.props.activeIndex == 4) {
      MENU_ITEMS[4].isEnabled = true;

      // split view mode with legend panel
      let panel = document
        ?.querySelector(".LegendPanel")
        ?.querySelector(".ListTitle");
      if (panel != undefined) {
        panel.innerHTML = "LEGEND (RIGHT SIDE MAP)";
      }
      this.props.reduxCallProxy(setSplitViewMode);
    } else {
      MENU_ITEMS[4].isEnabled = false;

      let panel = document
        ?.querySelector(".LegendPanel")
        ?.querySelector(".ListTitle");
      if (panel != undefined) {
        panel.innerHTML = "LEGEND";
      }
      this.props.reduxCallProxy(setSplitViewModeClose);
    }
  }

  render() {
    console.debug("LeftPanel Update");
    let { activeIndex } = this.props;
    return (
      <div
        className={"LeftPanel" + (this.props.collapsed ? " collapsed" : "")}
        style={{ display: this.props.isCompactMode ? "none" : "flex" }}
      >
        <div className="MenuButtonBar">
          <div className="AppName EqualWidthChildren">
            <div>
              <div className="GInfoIcon">
                <img src="ginfo_logo.png" />
              </div>
              GInfo
            </div>
          </div>
          {MENU_ITEMS.map((i, j) => (
            <div
              key={j}
              title={i.name}
              className={`icon ${activeIndex === j ? "active" : ""} ${
                !i.isEnabled ? "disabled" : ""
              }`}
              onClick={() => this.props.menuItemClickedCallback(i, j)}
            >
              <span className={i.icon} />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeMapType: () => dispatch(toggleMapType()),
    reduxCallProxy: function(reducer, payLoad) {
      dispatch(reducer(payLoad));
    },
  };
};

const mapStateToProps = function(state, ownProps) {
  // console.debug("mapStateToProps", JSON.stringify(state));
  return { mapType: state.global.mapType, reduxStore: state };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeftPanel);
// export default LeftPanel;
